import { Component, inject, Input } from '@angular/core';
import { LanguageService } from '@services/language.service';
import { EpxSvgIconComponent } from '@shared/components/misc/epx-svg-icon/epx-icon.component';

@Component({
    selector: 'app-epx-lang-select',
    template: `
        <section class="_language-selector" [class.collapsed]="!sidebarOpen">
            <div class="lang-selector-icon">
                <epx-svg-icon color="White" [size]="24" [icon]="'globe'"></epx-svg-icon>
            </div>
            <div class="lang-selector">
                <ul>
                    @for ((lang of languages()); track idx; let idx = $index) {
                        <li class="text-sm" (click)="selectLang(lang)" [class.active-lang]="lang === selectedLang()">
                            <a>
                                <span [textContent]="lang.toUpperCase()"></span>
                            </a>
                        </li>
                    }
                </ul>
            </div>
        </section>
    `,
    imports: [EpxSvgIconComponent],
    styleUrls: ['./epx-lang-select.component.scss']
})
export class EpxLangSelectComponent {
    languageService = inject(LanguageService);
    @Input() sidebarOpen = false;
    selectedLang = this.languageService.$language;
    languages = this.languageService.$availableLanguages;

    selectLang(lang: string) {
        this.languageService.setLanguage(lang);
    }
}
